<template>
    <div class="upload-file">
        <div class="uf_lists">
            <div style="display:flex;">
                <div v-for="(file, index) in fileList" :key="index" :style="{width: width + 'px', height: height + 'px'}"
                    class="uf_list">
                    <!--上传中-->
                    <div v-if="file.status === 'uploading'" class="uploading">
                        <p class="icon-bg"></p>
                        <p class="tip">上传中</p>
                        <p :title="file.name" class="name">{{ file.name }}</p>
                    </div>
                    <!--上传成功-->
                    <div v-if="file.status === 'success'" class="success">
                        <template v-if="type === 'img'">
                            <img :src="file.path" alt="" class="img" draggable="false">
                        </template>
                        <template v-else>
                            <p class="icon-bg"></p>
                            <p class="tip">上传成功</p>
                            <p :title="file.name" class="name">{{ file.name }}</p>
                        </template>
                        <p class="remove" @click="removeFile(index)"></p>
                    </div>
                    <!--上传失败-->
                    <div v-if="file.status === 'error'" class="error">
                        <p class="icon-bg"></p>
                        <p class="tip">上传失败</p>
                        <p :title="file.name" class="name">{{ file.name }}</p>
                        <p class="remove" @click="removeFile(index)"></p>
                    </div>
                </div>
                <!--上传按钮-->
                <div v-if="fileList.length < max" :style="{width: width + 'px', height: height + 'px'}"
                    class="uf_list uf_upload" @click="selectFile">
                    <div class="icon-bg"></div>
                    <div class="tip">{{ uploadTip }}</div>
                </div>
                支持jpg、jpeg、png格式的图片,不超过10M
            </div>
            <input ref="el-input" :accept="accept" :multiple="max !== 1" hidden type="file" @change="selectedFile" :rules="rules">
            
            <el-form :model="formLabelAlign" label-width="100px" label-position="left"  size="mini" style="width: 500px" :rules="rules" ref="formRef">
                <el-form-item label="拍品名称：" prop="WorkName">
                    <el-input v-model="formLabelAlign.WorkName" size="mini" maxlength="30"
                              type="text"
                    ></el-input>
                </el-form-item>
                <el-form-item label="拍品类别：" prop="SortName">
                    <el-select v-model="formLabelAlign.SortName" placeholder="请选择">
                      <el-option v-for="item in options" :key="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="拍品标签：" prop="WorkMark">
                    <el-input v-model="formLabelAlign.WorkMark" size="mini" maxlength="16"
                              type="text"
                              placeholder="如：瓶、明清等等，每个标签用空格分开"
                    ></el-input>
                </el-form-item>
                <el-form-item label="拍品尺寸：" prop="SizeInfo">
                    <el-input v-model="formLabelAlign.SizeInfo" size="mini" maxlength="16"
                              type="text"
                    ></el-input>
                </el-form-item>
                <el-form-item label="自报价：" prop="SoldPrice">
                    <el-input v-model="formLabelAlign.SoldPrice" size="mini" maxlength="16"
                              type="text"
                    ></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" prop="Phone">
                    <el-input v-model="formLabelAlign.Phone" size="mini" maxlength="16"
                              type="text"
                    ></el-input>
                </el-form-item>
                <el-form-item label="姓名：" prop="ConnectName">
                    <el-input v-model="formLabelAlign.ConnectName" size="mini" maxlength="8"
                              type="text"
                    ></el-input>
                </el-form-item>
                <el-form-item label="地址：" prop="Place">
                    <el-input v-model="formLabelAlign.Place" size="mini" maxlength="30"
                              type="text"
                    ></el-input>
                </el-form-item>
                <el-form-item label="邮箱：" prop="Email">
                    <el-input v-model="formLabelAlign.Email" size="mini"  maxlength="20"
                              type="text"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="setUpload">
                <el-button size="medium" type="primary" @click="handleClickBtn(true)">提交</el-button>
                <el-button size="medium" type="info" @click="handleClickBtn(false)">取消</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { getUploadAuth, uploadFile, uploadFileCheck, uploadFileMerge } from "./upload"
    import { getFileChunk } from "./file"
    import { computedMD5 } from "./md5"

    import { getZone, postDetail } from '@/api/company'

    export default {
        name: "UploadFile",
        props: {
            // 上传的文件类型
            type: {
                type: String,
                default: "img",
                validator: value => ["img", "audio", "video"].includes(value)
            },
            // 最多上传数量
            max: {
                type: Number,
                default: 9
            },
            // 最大上传尺寸
            maxSize: {
                type: Number,
                default: 1024 * 1024 * 10
            },
            // 宽度
            width: {
                type: Number,
                default: 120
            },
            // 高度
            height: {
                type: Number,
                default: 120
            },
            // 上传的提示语
            tip: {
                type: String,
                default: ""
            },
            // 已上传的文件
            uploadedFileList: {
                type: Array,
                default: () => []
            },
            formId: {
                type: Number,
                default: ''
            }
        },
        computed: {
            // 限制上传类型
            accept() {
                switch (this.type) {
                    case "img":
                        return "image/*"
                    case "audio":
                        return "audio/mp3,audio/mpeg,audio/basic,audio/3gpp,audio/ac3"
                    case "video":
                        return "video/*"
                    default:
                        return ""
                }
            },
            // 上传提示语
            uploadTip() {
                const map = {
                    img: "上传图片",
                    audio: "上传音频",
                    video: "上传视频"
                }
                if (this.tip) {
                    return this.tip
                } else {
                    return map[this.type]
                }
            }
        },
        watch: {
            uploadedFileList: {
                immediate: true,
                handler(val) {
                    if (val.length) {
                        this.fileList = val.map(file => {
                            return {
                                ...file,
                                status: "success"
                            }
                        })
                    } else {
                        this.fileList = []
                    }
                    this.emitRes()
                }
            }
        },
        data() {
            return {
                fileList: [],
                chunkSize: 1024 * 500,
                formLabelAlign: {
                    OrganCode: '',
                    CoverPic: '',
                    WorkName: '',
                    SortName: '',
                    WorkMark: '',
                    SizeInfo: '',
                    SoldPrice: '',
                    Phone: '',
                    ConnectName: '',
                    Place: '',
                    Email: ''
                },
                rules: {
                    WorkName: [
                        { required: true, message: "请正确输入", trigger: "blur" }
                    ],
                    WorkMark: [
                        { required: true, message: "请正确输入", trigger: "blur" }
                    ],
                    SortName: [
                        { required: true, message: "请正确输入拍品类别", trigger: "blur" }
                    ],
                    SizeInfo: [
                        { required: true, message: "请正确输入拍品尺寸", trigger: "blur" }
                    ],
                    SoldPrice: [
                        { required: true, message: "请正确输入自报价", trigger: "blur" },
                        { pattern: /^[0-9-\_]+$/, message: "请输入数字或 -", trigger: "blur"},
                    ],
                    Phone: [
                        { required: true, message: "请正确输入联系电话", trigger: "blur" },
                        { pattern: /^[0-9-\_]+$/, message: "号码格式不正确~", trigger: "blur"},
                    ],
                    ConnectName: [
                        { required: true, message: "请正确输入姓名", trigger: "blur" }
                    ],
                    Place: [
                        { required: true, message: "请正确输入地址", trigger: "blur" }
                    ],
                    Email: [
                        { required: true, message: "请正确输入邮箱", trigger: "blur" },
                        { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: "请正确按照格式输入", trigger: "blur" }
                    ],
                },
                options: [{
                    value: '中国书画',
                    label: '中国书画'
                },{
                    value: '古籍善本',
                    label: '古籍善本'
                },{
                    value: '西画雕塑',
                    label: '西画雕塑'
                },{
                    value: '陶瓷',
                    label: '陶瓷'
                },{
                    value: '玉石器',
                    label: '玉石器'
                },{
                    value: '鼻烟壶',
                    label: '鼻烟壶'
                },{
                    value: '佛教文物',
                    label: '佛教文物'
                },{
                    value: '竹木牙角器',
                    label: '竹木牙角器'
                },{
                    value: '古典家具',
                    label: '古典家具'
                },{
                    value: '珠宝翡翠',
                    label: '珠宝翡翠'
                },{
                    value: '邮品钱币',
                    label: '邮品钱币'
                },{
                    value: '工艺品杂项',
                    label: '工艺品杂项'
                },],
                upLoadState: true

            }
        },
        mounted() {
            const webName = this.$router.history.current.params.name;
            this.postDetail(webName);
            if(this.formId) {
                this.formLabelAlign.CollectId = this.formId
            }
        },
        methods: {
            // 弹出选择文件框
            selectFile() {
                this.$refs["el-input"].type = "text"
                this.$refs["el-input"].value = ""
                this.$refs["el-input"].type = "file"
                
                this.$refs["el-input"].accept = "jpg,jpeg,gif,png"
                this.$refs["el-input"].click()
            },
            // 选择文件
            selectedFile(e) {
                let files = Array.from(e.target.files)

                // 验证
                if (!this.verifyFile(files)) return

                // 对新上传的file进行一层包装，加上一些状态和必要的字段
                let newFileList = files.map(file => {
                    return {
                        name: file.name,
                        ext: file.name.split(".").reverse()[0].toLowerCase(),
                        status: "uploading",
                        size: file.size,
                        file
                    }
                })

                // 将新上传的file放入数组中，可以及时的在页面中显示出来，并且是等待状态
                this.fileList = [...this.fileList, ...newFileList]

                // 将当前组件正在上传文件的信息返回出去
                this.emitRes()

                // 上传文件
                newFileList.forEach(async file => {
                    await this.uploadFileSingle(file)
                })
            },
            // 验证文件数量和大小
            verifyFile(files) {
                if (files.length + this.fileList.length > this.max) {
                    this.$message.error(`最多上传${this.max}个文件${files.length ? `，已上传${files.length}个` : ""}`)
                    return false
                }
                if (files.some(file => file.size > this.maxSize)) {
                    this.$message.error(`不能上传大于${this.maxSize / 1024 / 1024}M的文件`)
                    return false
                }
                return true
            },
            // 上传单个文件
            async uploadFileSingle(file) {
                // 计算文件的MD5并将值付给包装对象上
                file.md5 = await computedMD5(file.file)

                // 获取加密值并将值付给包装对象上
                let auth = await getUploadAuth({
                    ext: file.ext,
                    size: file.size,
                    md5: file.md5
                })
                if (auth.code === 0) {
                    file.auth = auth.data.data
                } else {
                    this.uploadFileError(file, auth.msg || "获取加密值失败")
                    return
                }

                // 验证文件是否上传过，实现秒传
                let checkReq = {
                    sourceType: 15,
                    ext: file.ext,
                    size: file.size,
                    md5: file.md5,
                    auth: file.auth
                }
                if (this.type === "img") {
                    checkReq.img = 1
                }
                let check = await uploadFileCheck(checkReq)
                if (check.code === 1) {
                    // 文件已上传过 秒传成功
                    this.uploadFileSuccess(file, check.data)
                    return
                } else if (check.code !== 1 && check.code !== 0) {
                    this.uploadFileError(file, check.msg || "文件验证失败")
                    return
                }

                // 开始上传文件，是否需要切片上传
                if (file.size <= 500 * 1024) {
                    // 文件小于1M 不切片
                    let fd = new FormData()
                    fd.append("sourceType", 15)
                    fd.append("md5", file.md5)
                    fd.append("ext", file.ext)
                    fd.append("size", file.size)
                    fd.append("auth", file.auth)
                    if (this.type === "img") {
                        fd.append("img", 1)
                    }
                    fd.append("file", file.file)
                    let res = await uploadFile(fd)
                    if (res.code === 0) {
                        this.uploadFileSuccess(file, res.data)
                    } else {
                        this.uploadFileError(file, res.msg || "上传失败")
                    }
                } else {
                    // 文件大于1M 切片上传
                    let chunks = Math.ceil(file.size / this.chunkSize)
                    let chunk = 0

                    // 切片上传时，需要获取加密值，切片大小的共用一个加密值
                    // 这里需要请求两次，一次是切片大小的，一个是最后一个切片大小的
                    // 获取切片的加密值
                    let chunk_last = getFileChunk(file.file, this.chunkSize, chunks - 1)
                    let auth_chunk_size = await getUploadAuth({
                        ext: file.ext,
                        size: this.chunkSize,
                        md5: file.md5
                    })
                    let auth_chunk_last = await getUploadAuth({
                        ext: file.ext,
                        size: chunk_last.size,
                        md5: file.md5
                    })

                    // Fn - 使用递归控制切片按照顺序同步上传
                    const uploadChunk = async () => {
                        let item = getFileChunk(file.file, this.chunkSize, chunk)
                        let auth_chunk
                        if (item.size !== this.chunkSize) {
                            auth_chunk = auth_chunk_last.data
                        } else {
                            auth_chunk = auth_chunk_size.data
                        }

                        // 上传切片
                        let fd = new FormData()
                        fd.append("md5", file.md5)
                        fd.append("sourceType", 15)
                        fd.append("size", item.size)
                        fd.append("chunks", chunks)
                        fd.append("chunk", chunk)
                        if (this.type === "img") {
                            fd.append("img", 1)
                        }
                        fd.append("ext", file.ext)
                        fd.append("auth", auth_chunk)
                        fd.append("file", item.chunk, file.name)
                        let res = await uploadFile(fd)
                        if (res.code === 0) {
                            chunk ++
                            if (chunk < chunks) {
                                return await uploadChunk()
                            } else {
                                return true
                            }
                        } else {
                            return false
                        }
                    }

                    // 上传切片
                    let uploadRes = await uploadChunk()
                    if (!uploadRes) {
                        this.uploadFileError(file, "上传切片失败")
                        return
                    }

                    // 切片全部上传完，执行合并操作
                    let mergeReq = {
                        md5: file.md5,
                        ext: file.ext,
                        sourceType: 15,
                        size: file.size,
                        auth: file.auth,
                        chunks: chunks,
                        forceMerge: 1
                    }
                    if (this.type === "img") {
                        mergeReq.img = 1
                    }
                    let mergeRes = await uploadFileMerge(mergeReq)
                    if (mergeRes.code === 0) {
                        this.uploadFileSuccess(file, mergeRes.data)
                    } else {
                        this.uploadFileError(file, mergeRes.msg)
                    }
                }
            },
            // 单个文件上传成功
            uploadFileSuccess(file, data) {
                let { path, time, width, height } = data
                file.status = "success"
                file.path = path
                if (this.type === "img") {
                    file.width = width
                    file.height = height
                } else if (this.type === "audio") {
                    file.time = time
                } else if (this.type === "video") {
                    file.width = width
                    file.height = height
                    file.time = time
                }
                this.emitRes()
            },
            // 单个文件上传失败
            uploadFileError(file, tip) {
                file.status = "error"
                this.$Message.error(`${file.name}: ${tip}`)
                this.emitRes()
            },
            // 移除文件
            removeFile(index) {
                this.fileList.splice(index, 1)
                this.emitRes()
            },
            // 返回结果
            emitRes() {
                if (this.fileList.every(file => file.status !== "uploading")) {
                    // 上传完成了
                    this.$emit("on-uploaded", this.fileList.filter(file => file.status === "success"))
                } else {
                    // 还没上传完成
                    this.$emit("on-uploaded", null)
                }
            },
            init() {
                this.fileList = []
            },
            postDetail(name) {
                postDetail({
                    web_name: name,
                }).then((res) => {
                    console.log('送拍id',res.data.organ_id);
                    this.formLabelAlign.OrganCode = res.data.organ_id;
                    this.getSession();
                });
            },
            handleClickBtn(state) {
                if(state){
                    this.$refs.formRef.validate(isOk => {
                        if(isOk && this.fileList.length) {
                            this.formLabelAlign.CoverPic = this.fileList[0].path;

                            if(!this.upLoadState) return
                            this.upLoadState = false

                            getZone(this.formLabelAlign).then(res => {
                                this.upLoadState = true
                                if(res.code == '0'){
                                    this.deleFormLabelAlign()
                                    this.$message.success('提交成功')
                                    this.$emit('closeDialog')
                                }else {
                                    this.$message(res.message)
                                }
                            })

                        }else {
                            this.$message('请按要求填写');
                        }
                    })
                } else {
                    this.deleFormLabelAlign()
                    this.$emit('closeDialog')
                }
            },
            deleFormLabelAlign() {
                // this.fileList.file.name
                if(this.fileList[0]){
                    this.removeFile(0)
                }
                this.formLabelAlign = {
                    OrganCode: '',
                    CoverPic: '',
                    SortName: '',
                    WorkName: '',
                    WorkMark: '',
                    SizeInfo: '',
                    SoldPrice: '',
                    Phone: '',
                    ConnectName: '',
                    Place: '',
                    Email: ''
                }
            }
        }
    }
</script>

<style lang="scss">
    .upload-file {
        width: 100%;
        height: 600px;
        .uf_lists {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            .uf_list {
                width: 120px;
                height: 120px;
                background: #f6f7f9;
                border-radius: 4px;
                margin: 0 15px 15px 0;
                .uploading,
                .success,
                .error {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    .icon-bg {
                        width: 22px;
                        height: 22px;
                    }
                    .tip {
                        font-family: MicrosoftYaHei;
                        line-height: 19px;
                        margin: 10px 0;
                    }
                    .name {
                        font-size: 12px;
                        color: #A0A7B8;
                        width: 90%;
                        text-align: center;
          
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        
                    }
                    .remove {
                        width: 16px;
                        height: 16px;
                        background: url("./remove.png");
                        background-size: 100%;
                        position: absolute;
                        top: -8px;
                        right: -8px;
                        cursor: pointer;
                    }
                }
                .uploading {
                    .icon-bg {
                        @keyframes myRotate {
                            0% {
                                transform: rotate(0deg);
                            }
                            50% {
                                transform: rotate(180deg);
                            }
                            100% {
                                transform: rotate(360deg);
                            }
                        }
                        animation: myRotate 2s linear infinite;
                        background: url("./loading.png");
                        background-size: 100%;
                    }
                }
                .success {
                    .icon-bg {
                        background: url("./success.png");
                        background-size: 100%;
                    }
                    .img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 4px;
                    }
                }
                .error {
                    .icon-bg {
                        background: url("./warning.png");
                        background-size: 100%;
                    }
                }
                &.uf_upload {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    user-select: none;
                    .icon-bg {
                        width: 22px;
                        height: 22px;
                        background: url("./upload.png");
                        background-size: 100%;
                    }
                    .tip {
                        height: 19px;
                        font-family: MicrosoftYaHei;
                        line-height: 19px;
                        margin-top: 10px;
                        color: #515A6E;
                        font-size: 14px;
                    }
                }
            }
        }
    }
    .el-form--label-left .el-form-item__label {
        text-align: right;
    }
    .setUpload {
        text-align: center;
    }
</style>
